import { mapDTO } from '@twistezo/ts-dto-mapper'
import { getFragmentData } from 'gql'
import { AuthUserCurrentWorkspaceFragmentFragmentDoc } from 'gql/graphql'

import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { dataSamplingFromDTO } from 'features/workspace/mappers/dataSampling'

import type { AuthUserCurrentWorkspaceDTO, AuthUserDTO } from './types'
import type { FeatureFlag } from 'features/user/types/featureFlag'
import type { User, UserCurrentWorkspace, UserFeature } from 'features/user/types/user'
import type { WorkspaceAlert } from 'features/workspace/types/workspaceAlert'

export const authUserCurrentWorkspaceFromDTO = (
  from: AuthUserCurrentWorkspaceDTO,
): UserCurrentWorkspace => ({
  active: from.active,
  alerts: alertsFromDTO<WorkspaceAlert>(from.alerts),
  id: from.id,
  latestGamConnectionOrder: from.latestGamConnectionOrder ?? undefined,
  name: from.name,
  networkCode: from.networkCode ?? '',
  pipedriveLink: from.pipedriveLink,
  prebidManagerSampling: dataSamplingFromDTO(from.prebidManagerSampling),
  priceGeniusAlwaysOn: from.priceGeniusAlwaysOn,
  primaryCurrency: from.primaryCurrency ?? undefined,
})

export const authUserFromDTO = (from: AuthUserDTO): User =>
  mapDTO<AuthUserDTO, User>({ from }).transform(
    (dto: AuthUserDTO): User => ({
      currentWorkspace: dto.currentWorkspace
        ? authUserCurrentWorkspaceFromDTO(
            getFragmentData(AuthUserCurrentWorkspaceFragmentFragmentDoc, dto.currentWorkspace),
          )
        : undefined,
      currentWorkspaceRole: dto.currentWorkspaceRole || undefined,
      email: dto.email,
      features: dto.features.map(
        ({ enabled, name }): UserFeature => ({
          enabled: enabled ?? false,
          name: name as FeatureFlag,
        }),
      ),
      firstName: dto.firstName || '',
      id: dto.id,
      lastName: dto.lastName || '',
      role: dto.role,
      workspaceProducts: dto.workspaceProducts || undefined,
      workspaces: dto.workspaces.map(({ alerts, id, name, networkCode }) => ({
        alerts: alertsFromDTO<WorkspaceAlert>(alerts),
        id,
        name,
        networkCode: networkCode ?? '',
      })),
    }),
  )
